import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import SpinnerComponent from "../../components/atoms/spinner/spinner.component";
import { getProductBySlugAPI } from "../Home-Page/home-page.component.service";
import { useDispatch } from "react-redux";
import { addToCart } from "../../reducers/app.reducer";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import FooterComponent from "../Footer/footer.component";

const ProductDetailsComponent = () => {
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);

  const onload = async () => {
    try {
      setLoading(true);
      const response = await getProductBySlugAPI(slug);
      if (response.status) {
        setProduct(response.data);
      } else {
        setError("Product not found");
      }
    } catch (err) {
      setError("Failed to fetch product details");
      console.error("Error fetching product:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (slug) {
      onload();
    }
  }, [slug]);

  const handleAddToCart = (row) => {
    const match = row.inventory_details;

    if (!match) {
      MySwal.fire({
        title: <strong>No Match!</strong>,
        html: (
          <i>{row.inventory_details.part_number} is not found in inventory</i>
        ),
        icon: "error",
      });
      return;
    }
    console.log("qty check",row.inventory_details.min_qty);
    

    const matchedQty = row.inventory_details.min_qty || 10;

    // Proceed with adding to cart
    proceedWithAddToCart(row, match, matchedQty);
  };

  // Helper function to handle the actual add to cart logic
  const proceedWithAddToCart = (row, match, matchedQty) => {
    // console.log({matchedQty});

    let priceList = [];
    if (Array.isArray(match.price)) {
      const sortedPrices = [...match.price].sort((a, b) => {
        const aQty = parseInt(a.slab.replace("slab_", ""));
        const bQty = parseInt(b.slab.replace("slab_", ""));
        return aQty - bQty;
      });

      priceList = sortedPrices.map((p) => ({
        min_qty: parseInt(p.slab.replace("slab_", "")),
        price: parseFloat(p.price),
      }));
    }

    if (matchedQty < match.min_qty) {
      MySwal.fire({
        title: <strong>Low Quantity!</strong>,
        html: (
          <i>
            Quantity for {row.inventory_details.part_number} is less than{" "}
            {match.min_qty}
          </i>
        ),
        icon: "warning",
      });
      return;
    }

    const cartProduct = {
      ...match,
      required_qty: matchedQty,
      price: {
        min_order: matchedQty,
        multiple: matchedQty,
        price_list: priceList,
      },
      manufacturer: match.make,
    };

    console.log({ cartProduct });

    MySwal.fire({
      title: <strong>Cart Update!</strong>,
      html: (
        <i>
          You've added {row.inventory_details.part_number} (Qty: {matchedQty})
          to your cart
        </i>
      ),
      icon: "success",
    });

    dispatch(addToCart(cartProduct));
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: 64 }}>
        <SpinnerComponent />
      </div>
    );
  }

  if (error) {
    return (
      <div className="ds-container" style={{ paddingBlock: 48 }}>
        <div className="ds-state">
          <h3>{error}</h3>
          <button onClick={() => window.history.back()} className="ds-btn ds-btn-secondary">
            Go Back
          </button>
        </div>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="ds-container" style={{ paddingBlock: 48 }}>
        <div className="ds-state">
          <h3>Product not found</h3>
          <button onClick={() => window.history.back()} className="ds-btn ds-btn-secondary">
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="ds-container">
      <div className="ds-page-head">
        <p className="ds-eyebrow">Product family</p>
        <h1>{product.name}</h1>
      </div>

      <div className="ds-card-grid cols-4" style={{ paddingBottom: 56 }}>
        {product.repeater?.map((item) => (
          <div key={item.id} className="ds-product-card">
            <span className="ds-thumb">
              {item.inventory_details?.image ? (
                <img src={item.inventory_details.image} alt={item.inventory_details.part_number} />
              ) : null}
            </span>
            <div className="ds-product-body">
              <span className="ds-mpn">{item.inventory_details?.part_number || "N/A"}</span>
              <span className="ds-maker">{item.inventory_details?.manufacturer || "N/A"}</span>
              <span className="ds-desc">
                {item.inventory_details?.description || "No description available"}
              </span>
              <div className="ds-row" style={{ marginTop: "auto", paddingTop: 8, flexWrap: "nowrap" }}>
                <Link
                  to={`/product/${item?.inventory_details?.part_number || item.product_name}`}
                  className="ds-btn ds-btn-secondary ds-btn-sm"
                  style={{ flex: 1 }}
                >
                  View
                </Link>
                <button
                  onClick={() => handleAddToCart(item)}
                  className="ds-btn ds-btn-primary ds-btn-sm"
                  style={{ flex: 1 }}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductDetailsComponent;
